import React from 'react';
import { useJsApiLoader } from "@react-google-maps/api";
import { EMPTY_VALUE, GOOGLE_MAP_KEY } from "@src/core/config";
import { ArcGlobalLoading } from "@src/core/widgets";
import { RootProps } from '@src/root/types';
import { useDispatch } from 'react-redux';
import { setMapLocation } from '@src/core/controllers';
import { useGetUserDataQuery } from '@src/core/features';

function withRootInitialize<WCP extends object>(Wrapped: React.ComponentType<WCP & RootProps>) {

  const Component: React.FC<WCP> = () => {
    const dispatch = useDispatch();
    const { isLoaded } = useJsApiLoader({ googleMapsApiKey: GOOGLE_MAP_KEY, libraries: ['places', 'geometry', 'drawing'] });
    const { data: userData, isLoading } = useGetUserDataQuery();

    React.useEffect(() => {
      const latitude = Number(userData?.hub?.latitude);
      const longitude = Number(userData?.hub?.longitude);

      if (isNaN(latitude) || isNaN(longitude) || !isLoaded) return;

      dispatch(setMapLocation({ 
        address: EMPTY_VALUE, 
        latitude: latitude, 
        longitude: longitude,
      }));
    
    }, [userData?.hub, isLoaded, dispatch]);

    if (isLoading || isLoading == undefined || !isLoaded) {
      return <ArcGlobalLoading />;
    }

    const rootProps = { userData };

    return <Wrapped {...rootProps as (WCP & RootProps)} />;
  };

  return Component;
}

export default withRootInitialize;